/**
 * @metaarena/sdk 타입 정의
 */

/** onStart() 콜백으로 전달되는 게임 시작 컨텍스트 */
export interface GameStartContext {
  /** 현재 토너먼트 UUID */
  tournamentId: string
  /** 플레이어 JWT — 서버 사이드 게임에서 서버로 전달해 점수 제출 시 사용 */
  playerToken: string
  /** MetaArena API 베이스 URL (환경별 자동 설정) */
  apiBase: string
}

/** gameOver() 에 전달하는 페이로드 */
export interface GameOverPayload {
  /** 최종 점수 (0 이상 정수) */
  score: number
  /** 총 플레이 시간 (밀리초). 서버 범위 검증에 활용되므로 포함 권장 */
  playTimeMs?: number
}

// ── 플랫폼 → 게임 (수신) ─────────────────────────────────────

export interface GameStartMessage {
  type: 'METAARENA_GAME_START'
  tournament_id: string
  player_token: string
  api_base?: string
}

// ── 게임 → 플랫폼 (송신) ─────────────────────────────────────

export interface ReadyMessage    { type: 'METAARENA_READY' }
export interface ScoreMessage    { type: 'METAARENA_SCORE'; score: number }
export interface GameOverMessage { type: 'METAARENA_GAME_OVER'; score: number; play_time_ms?: number }

export type OutboundMessage = ReadyMessage | ScoreMessage | GameOverMessage
export type InboundMessage  = GameStartMessage

/** SDK 에러 */
export class SDKError extends Error {
  constructor(message: string, public readonly code: string) {
    super(message)
    this.name = 'SDKError'
  }
}
